<template lang="">
  <v-container
    v-if="
      user.permissions.indexOf(permissionsAll.step_update) >= 0 ||
        user.person.types_person.id === 3
    "
  >
    <BreadCrumbs :items="itemsBreadCrumbs" />
    <FormStep @sendForm="sendForm" :actionForm="actionForm" />
  </v-container>
</template>
<script>
import { beginRequest, endRequest, itemsBreadCrumbs } from "../../helpers";
import { FormStep } from "../../components/steps";
import { BreadCrumbs } from "../../components/_commons";
import permissions from "../../helpers/permissions";
import { mapState } from "vuex";

export default {
  name: "StepEdit",
  components: {
    BreadCrumbs,
    FormStep,
  },
  data() {
    return {
      itemsBreadCrumbs: itemsBreadCrumbs.stepEdit,
      actionForm: "Edit",
      permissionsAll: permissions,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async sendForm(formData) {
      await beginRequest();
      const payload = {
        id: this.$route.params.idstep,
        data: formData,
      };
      const { snack, status } = await this.$store.dispatch(
        "updateStep",
        payload
      );
      await endRequest(snack, status);
    },
  },
};
</script>
